import { MiniBetSlipSchema } from './MiniBetSlip.styles';

export const miniBetSlipStyles: MiniBetSlipSchema = {
  wrapper: {
    mx: ['0', null, '-4'],
    mb: ['0', null, '-4'],
    bottom: '0',
    left: '0',
    position: ['fixed', null, null, 'sticky'],
    right: '0',
    zIndex: 'sticky',
    bg: 'alpha.500',
    borderBottomRadius: 'md',
  },
  slideBox: {
    bg: 'alpha.600',
    color: 'white',
    borderTopWidth: '3px',
    borderTopColor: 'beta.300',
    borderBottomRadius: 'base',
  },
  accordionItem: {
    borderTop: '3px',
    borderColor: 'gamma.500',
    borderTopWidth: '0',
    _last: {
      borderBottomWidth: '0',
    },
  },
  accordionHeaderText: {
    boxShadow:
      '0 1px rgba(255, 255, 255, .15), 0 1px rgba(255, 255, 255, .15) inset',
  },
  accordionButton: {
    bg: 'alpha.600',
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'body',
    gap: '1',
    px: '4',
    py: '3',
    color: 'white',
    borderTop: '3px',
    borderColor: 'beta.500',
    _hover: {
      bg: 'alpha.600',
    },
  },
  accordionButtonIcon: {
    fontSize: 'sm',
    pos: 'relative',
    bottom: '0.5',
  },
  headerStack: {
    bg: 'alpha.800',
    borderRadius: 'base',
    bottom: '100%',
    fontSize: 'xs',
    fontWeight: 'medium',
    left: '50%',
    pos: 'absolute',
    px: '4',
    py: '2',
  },
  headerText: {
    flex: '1',
  },
  headerButton: {
    display: 'inline-flex',
    fontSize: 'xl',
    minW: '0',
  },
  accordionPanel: {
    bg: 'alpha.800',
    fontSize: 'xs',
    maxH: '32',
    overflow: 'auto',
    p: '0',
  },
  selectionFlex: {
    borderColor: 'rgba(0, 0, 0, 0.25)',
    bg: 'alpha.400',
    gap: '2',
    p: '2',
    pos: 'relative',
    _notFirst: {
      borderTopStyle: 'dashed',
      borderTopWidth: '1px',
    },
    _before: {
      border: 'inherit',
      borderColor: 'whiteAlpha.300',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  selectionMarketName: {
    flex: '1',
    fontWeight: 'bold',
  },
  selectionPropositionName: {
    flex: ['1', null, '2', null, '3'],
  },
  footerStack: {
    bg: 'blackAlpha.400',
    direction: 'row',
    fontSize: 'sm',
    fontWeight: 'semibold',
    py: '2.5',
    px: '4',
    pos: 'relative',
    borderTopColor: 'blackAlpha.300',
    borderBottomRadius: 'md',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    _before: {
      opacity: '0.2',
      bottom: 'calc(100% + 1px)',
      content: '""',
      h: '4',
      left: '0',
      pointerEvents: 'none',
      pos: 'absolute',
      right: '0',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
  },
  footerHStack: {
    flex: '1',
  },
  legsText: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '2xs',
  },
  legsChunks: {
    color: 'beta.300',
    fontFamily: 'body',
    fontSize: 'xl',
    fontWeight: 'bold',
  },
  oddsText: {
    color: 'white',
    textTransform: 'uppercase',
    flex: '3',
    display: 'flex',
    fontWeight: 'bold',
    flexDirection: 'column',
    fontSize: '2xs',
  },
  oddsSkeletonLoader: {
    display: 'inline-block',
    ml: '1',
    w: '8',
  },
  oddsChunks: {
    color: 'beta.300',
    fontFamily: 'body',
    fontSize: 'xl',
    fontWeight: 'bold',
  },
  clearButton: {
    variant: 'outline',
    fontSize: '11px',
    textTransform: 'uppercase',
  },
  addToSlipButton: {
    variant: 'solid',
    fontSize: '11px',
    textTransform: 'uppercase',
    px: ['1', '3'],
  },
};
